import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { Cacheable } from 'ngx-cacheable';

import { environment } from '../environments/environment';
import { TotemConfiguracion } from './totem-configuracion';
import { estacionamientos } from './estacionamientos/estacionamientos';

import { Tienda } from './tiendas/tienda';
import { Categoria } from './tiendas/categoria';

const cacheBuster$ = new Subject<void>();
@Injectable({
  providedIn: 'root'
})
export class TotemService {
  protected basePath = environment.apiURL;
  protected totemConfig: TotemConfiguracion = null;

  private subject = new Subject<any>();

  public portugues: any;
  public espanol: any;
  public ingles: any;

  public actualLanguage: any = 'es';

  constructor(private http: HttpClient) {
    this.getTextos('es').subscribe(textos => {
      this.espanol = textos;
      console.log('this.espanol',this.espanol);
    });

    this.getTextos('en').subscribe(textos => {
      this.ingles = textos;
      console.log('this.ingles',this.ingles);
    });

    // this.getTextos('pr').subscribe(textos => {
    //   this.portugues = textos;
    // });
   }

  async getTotemConfig(totem): Promise<TotemConfiguracion> {
    if ( !this.totemConfig) {
      const path  = 'getTotem';
      const totemConfig = await this.http.post(this.basePath + path, { totem }).toPromise();
      this.totemConfig  = new TotemConfiguracion(totemConfig);
      console.log('getTotemConfig ', this.totemConfig);
    } 
    return this.totemConfig;
  }

  async setTotemConfig(totem): Promise<TotemConfiguracion> {
    const totemConfig = await this.http.post(this.basePath + 'getTotem', { totem }).toPromise();
    this.totemConfig  = new TotemConfiguracion(totemConfig);
    // Antes se forzaba orientacionId = 101 (hardcode desde 2021, ver git log).
    // Ningún tótem/nodo de este edificio usa orientación 101 (todos usan la
    // real, ej. 134), por lo que el filtro de nodos en AnimateMapService
    // quedaba vacío y el tótem no encontraba su propio nodo -> crash en
    // animate-map.service.ts al leer numero_piso de undefined.
    // Se respeta el valor real que ya trae TotemConfiguracion desde el backend.
    return this.totemConfig;
  }

  async getAllTotems() {
      const path  = 'getTotem';
      const totemConfig = await this.http.post(this.basePath + path, { 'totem': 0 }).toPromise();
      const listaTotems  = totemConfig;
      console.log('listaTotems ', listaTotems);
      return listaTotems;
  }

  // --------------------------------------------
  changeLanguage(language: string) {
    this.actualLanguage = language;
    this.subject.next(language);
  }
  getLanguage(): Observable<any> {
    return this.subject.asObservable();
  }
  getLanguageact() {
    return this.actualLanguage;
  }


  languageText(idioma: string) {
    let language = '';

    switch (idioma) {
      case 'es':
        language = 'Esp';
        break;
      case 'en':
        language = 'Ing';
        break;
      default:
        language = 'Esp';
        break;
    }

    return language;
  }
  // Translation
  getTranslation(key: string) {
    const lang =  this.languageText(this.actualLanguage);
    // console.log('this.actualLanguage',this.actualLanguage)
    if (lang === 'Esp' && this.espanol) {
      return this.espanol.filter(word => word.texto_clave === key && word.idioma_clave === lang);
    }
    if (lang === 'Ing' && this.ingles) {
      return this.ingles.filter(word => word.texto_clave === key && word.idioma_clave === lang);
    }
  }
  // get textos
  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getTextos(idioma: any): Observable<any> {
    const language = this.languageText(idioma);

    const path   = 'getTextos';
    const params = {
      edificio: environment.edificio,
      idioma: language
    };
    return this.http.post(this.basePath + path, params);
  }
  // --------------------------------------------
  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getTiendas(idioma: any): Observable<any> {
    const path   = 'getPuntosInteres';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  getTipoAccesos(): Observable<any> {
    const idiomaSelec = this.languageText(this.actualLanguage);
    const path   = 'getTipoAccesos';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal,
      idioma  : idiomaSelec,
    };
    return this.http.post(this.basePath + path, params);
  }

  getAccesos(access): Observable<any> {
    const path   = 'getAccesos';
    const params = {
      edificio   : environment.edificio,
      tipo_acceso: access,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getCategorias(idioma:string): Observable<any> {
    console.log('idioma en get categorias -> ', idioma);
    const idiomaSelec = this.languageText(idioma);
    const path   = 'getCategorias';
    const params = {
      edificio: environment.edificio,
      idioma  : idiomaSelec,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getPlanos(): Observable<any> {
    const path   = 'getPlanos';
    
    const orientacion = this.totemConfig ? this.totemConfig.orientacionId : environment.orientacionHor[0];
    // console.log('this.totemConfig.orientacionId', orientacion);
    const params = {
      orientacion: orientacion,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getPlanosById(orientacionId): Observable<any> {
    const path   = 'getPlanos';

    const params = {
      orientacion: orientacionId,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getNodos(): Observable<any> {
    const path   = 'getNodos';
    const params = {
      edificio: environment.edificio,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getRutaPi(): Observable<any> {
    const path   = 'getRutasPI';
    const params = {
      edificio: environment.edificio,
      totem   : environment.totem,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getRutasAccesos(): Observable<any> {
    const path   = 'getRutasAcc';
    const params = {
      edificio: environment.edificio,
      totem   : environment.totem,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getpublicidades(): Observable<any> {
    const path   = 'getPublicidad';
    const params = {
      edificio: environment.edificio,
      canal   : environment.canal
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  geteventos(idi:any): Observable<any> {
    const idiomaSelec = this.languageText(idi);
    console.log('geteventos->idiomaSelec',idiomaSelec);
    const path   = 'getEventos';
    const params = {
      edificio: environment.edificio,
      idioma  : idiomaSelec,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getPuntos(): Observable<any> {
    const path   = 'getPuntos';
    const params = {
      //edificio: environment.edificio,
      idioma  : environment.idioma,
    };
    return this.http.post(this.basePath + path, params);
  }

  @Cacheable({
    cacheBusterObserver: cacheBuster$
  })
  getTotemPuntoInteres(idLocal): Observable<any> {
    const path = 'getTotemPuntoInteres';
    const params = {
      idLocal,
    };
    return this.http.post(this.basePath + path, params);
  }

  isOpen = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  emitirReinicioTotem() {
    this.isOpen = !this.isOpen;
    this.change.emit(this.isOpen);
  }

  // funcion para ordenar alfabeticamente
  public sortByKey(array) {
    return array.sort((a, b) => {
      const x = a.nombre;
      const y = b.nombre;
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

   // funcion para eliminar caracteres extraños
   eliminarDiacriticos(texto) {
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  eliminarFiltrados(tiendasporfiltrar: any, tiendasfiltradas: any) {
    const nuevalista = tiendasporfiltrar.filter( tienda => {
      return tiendasfiltradas.indexOf(tienda) === -1;
    });
    return nuevalista;
  }
  async obtenerTiendasOrdenadas(idioma: string) {
    try {
    let resultado = await this.getTiendas(idioma).toPromise();
    resultado = resultado.map((tienda: any) => new Tienda(tienda));
    resultado = resultado.filter(tienda => {
      if (tienda.estado.toString() === 'Habilitado' ||
      tienda.estado.toString() === 'Proximamente') {
        return tienda;
      }
    });
    return resultado;
    } catch (err) {
      console.error(err);
    }
  }

  async obtenerCategoriasPorTiendas(idioma:string, ListaDeTiendas: any) {
    const subcategorias = [];
    const items = await this.getCategorias(this.actualLanguage).toPromise();
    const categorias = items.map(item => new Categoria(item));
    const subCategoriasResult = [];
    for (const categoria of categorias) {
      const subcategorias = categoria.subcategorias;
      for (const subcategoria of subcategorias) {
        subcategoria.tiendas = ListaDeTiendas.filter((tienda: Tienda) => {
          return tienda.subcategorias.find(idSubcategoria => {
            return idSubcategoria === subcategoria.id;
          });
        });
        subCategoriasResult.push(subcategoria);
      }
    }
    // insertar categorias en lista
    for (const subcat of subCategoriasResult) {
      if (subcat.tiendas.length !== 0) {
        const nombre = subcat.nombre.toLowerCase();
        subcat.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
        subcategorias.push(subcat);
      }
    }
    return subcategorias;
  }

  getEstacionamientoPorID(idEstacionamiento: any) {
    let est = []
    est = estacionamientos.filter((estacionamiento) =>{
      return estacionamiento.piid === idEstacionamiento;
    });
    return est[0].nombre;
  }
}
